import { useState } from "react";
import {
  AmazonListingsItemsPostRequest,
  AmazonApi,
  RequestUpsertListingsItemsRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";
import { isLwaNotConnectedError } from "../../utils/lwaError";

// 同じユーザーの同期がすでに実行中のときにバックエンドが返すコード
const SYNC_ALREADY_RUNNING_CODE = "SYNC_ALREADY_RUNNING";

export const useApiUpsertListingsItems = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // 同期はバックグラウンドで実行されるため、ここでは開始できたかどうかだけを返す。
  // 完了と結果は getSyncItemsStatus で確認する。
  const upsertListingsItems = async (
    req: RequestUpsertListingsItemsRequest
  ): Promise<{ ok: boolean; notConnected: boolean; alreadyRunning: boolean }> => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: AmazonListingsItemsPostRequest = { req };
      const api = new AmazonApi(config);

      await api.amazonUpsertListingsItemsPost(request);
      setResult(true);
      return { ok: true, notConnected: false, alreadyRunning: false };
    } catch (err) {
      const notConnected = isLwaNotConnectedError(err);
      const alreadyRunning =
        (err as any)?.response?.data?.code === SYNC_ALREADY_RUNNING_CODE;
      setError(notConnected ? "LWA_NOT_CONNECTED" : "商品の同期に失敗しました");
      console.error(err);
      return { ok: false, notConnected, alreadyRunning };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    upsertListingsItems,
    error,
    isLoading,
  };
};
